import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.066 23.7V8.302a1 1 0 1 1 2 0v15.4a1 1 0 0 1-2 0"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M26.293 20.06a1 1 0 0 1 1.414 1.415l-2.933 2.933a1 1 0 0 1-1.414 0l-2.933-2.933a1 1 0 1 1 1.414-1.414l2.225 2.225zM15.733 11.235a3.4 3.4 0 0 0-3.4-3.4H9.4a3.4 3.4 0 0 0-3.4 3.4v9.533a3.4 3.4 0 0 0 3.4 3.4h2.933a3.4 3.4 0 0 0 3.4-3.4zm2 9.533a5.4 5.4 0 0 1-5.4 5.4H9.4a5.4 5.4 0 0 1-5.4-5.4v-9.533a5.4 5.4 0 0 1 5.4-5.4h2.933a5.4 5.4 0 0 1 5.4 5.4z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.866 15.635v-3.667a1 1 0 0 1 2 0v3.667a1 1 0 0 1-2 0"
    }, null, -1)
  ]))]))
}
export default { render: render }